<div
  style="
    font-family: 'Nunito', sans-serif 4px 8px;
    box-sizing: border-box;
    width: 210mm;
    height: 297mm;
  "
>
  <div>
    <div class="header-template">
      <div class="header-template-left">
        <img
          [src]="userCardAssets?.logoHeader"
          alt="lex-logo"
          class="header-logo-template"
        />
      </div>
      <div class="header-template-right">
        <span
          class="header-school-name"
          [style.color]="userCardAssets?.color"
          >{{ wrapperInfo?.schoolName }}</span
        >
      </div>
    </div>
    <div
      style="
        text-align: center;
        width: 409px;
        margin: 0 auto;
        margin-bottom: 24px;
      "
    >
      <span
        [style.color]="userCardAssets?.color"
        style="
          font-size: 20px;
          font-weight: 700;
          display: inline-block;
          text-align: center;
          font-family: 'Nunito', sans-serif;
        "
        >{{ welcomeMessage }}</span
      >
    </div>
    <div style="display: block; margin-bottom: 24px">
      <p
        style="
          font-weight: 400;
          font-size: 16px;
          color: #555555;
          margin: 0 auto;
          width: 409px;
          text-align: center;
          font-family: 'Nunito', sans-serif;
        "
      >
        {{ this.lextranslate.i18n["140a90f2-7d7a-48b4-8719-a1c60615aed5"] }}
      </p>
    </div>
  </div>
  <div
    style="display: block; width: 100%; text-align: center; margin-bottom: 66px"
  >
    <seb-access-card
      [cardInfo]="wrapperInfo"
      [userCardAssets]="userCardAssets"
    ></seb-access-card>
  </div>
  <div
    [style.border]="'3px solid ' + userCardAssets?.color"
    style="
      margin: 0 auto;
      min-height: 153px;
      width: 546px;
      border-radius: 8px;
      padding: 24px;
      box-sizing: border-box;
      margin-bottom: 24px;
    "
    *ngIf="wrapperInfo?.isOnlyStudent"
  >
    <div
      style="
        display: inline-block;
        align-items: center;
        margin-bottom: 16px;
        width: 50%;
      "
    >
      <div style="display: inline-block; width: 100%">
        <div
          [style.color]="userCardAssets?.color"
          style="
            font-weight: 700;
            font-size: 14px;
            line-height: 22.4px;
            font-family: 'Nunito', sans-serif;
          "
        >
          {{ lextranslate.i18n["bb07b844-c2e4-4ce1-b14a-d8ea9ddddd1b"] }}
        </div>
        <div
          style="
            font-weight: 400;
            font-size: 14px;
            color: #555555;
            line-height: 22.4px;
            font-family: 'Nunito', sans-serif;
            margin-bottom: 8px;
          "
        >
          {{ wrapperInfo?.guardianName }}
        </div>
      </div>
      <div style="display: inline-block; width: 100%">
        <div
          [style.color]="userCardAssets?.color"
          style="
            font-weight: 700;
            font-size: 14px;
            line-height: 22.4px;
            font-family: 'Nunito', sans-serif;
          "
        >
          {{ lextranslate.i18n["17cc5c36-f25f-4667-bf20-a3db73be1909"] }}
        </div>
        <div
          style="
            font-weight: 400;
            font-size: 14px;
            color: #555555;
            line-height: 22.4px;
            font-family: 'Nunito', sans-serif;
          "
        >
          {{ wrapperInfo?.cellphone }}
        </div>
      </div>
    </div>
    <div style="display: inline-block; float: right; width: 50%">
      <div style="display: inline-block; width: 100%">
        <div
          [style.color]="userCardAssets?.color"
          style="
            font-weight: 700;
            font-size: 14px;
            line-height: 22.4px;
            font-family: 'Nunito', sans-serif;
          "
        >
          {{ lextranslate.i18n["895c26e7-13c8-4ccc-9b9e-55a7b8e64361"] }}
        </div>
        <div
          style="
            font-weight: 400;
            font-size: 14px;
            color: #555555;
            line-height: 22.4px;
            font-family: 'Nunito', sans-serif;
            margin-bottom: 8px;
            word-break: break-word;
          "
        >
          {{ wrapperInfo?.email }}
        </div>
      </div>
      <div style="display: inline-block; width: 100%">
        <div
          [style.color]="userCardAssets?.color"
          style="
            font-weight: 700;
            font-size: 14px;
            line-height: 22.4px;
            font-family: 'Nunito', sans-serif;
          "
        >
          CPF
        </div>
        <div
          style="
            font-weight: 400;
            font-size: 14px;
            color: #555555;
            line-height: 22.4px;
            font-family: 'Nunito', sans-serif;
          "
        >
          {{ wrapperInfo?.documentId | cpfMask }}
        </div>
      </div>
    </div>
  </div>
  <div
    style="text-align: center; display: block"
    *ngIf="wrapperInfo?.isOnlyStudent"
  >
    <div
      [style.color]="userCardAssets?.color"
      style="
        font-weight: 700;
        font-size: 14px;
        line-height: 22.4px;
        margin-bottom: 8px;
        font-family: 'Nunito', sans-serif;
        text-align: center;
      "
    >
      {{ this.lextranslate.i18n["b7ee28ea-9f66-4033-b1bf-0d1801942460"] }}
    </div>
    <div
      style="
        font-weight: 400;
        font-size: 14px;
        line-height: 22.4px;
        color: #555555;
        display: inline-block;
        width: 327px;
        margin: 0 auto;
        margin-bottom: 17px;
        font-family: 'Nunito', sans-serif;
        text-align: center;
      "
    >
      {{ this.lextranslate.i18n["663bc971-7f0a-4635-81db-265b82e7ffb1"] }}
    </div>
    <div
      style="
        font-weight: 700;
        font-size: 14px;
        line-height: 22.4px;
        color: #555555;
        font-family: 'Nunito', sans-serif;
        text-align: center;
      "
    >
      {{ this.lextranslate.i18n["873b6a76-87ea-494d-92e9-0813d9e71425"] }}
    </div>
  </div>
</div>
